import { getDefaultAxiosInstance } from '..';
import { CORE_SERVER_HOST } from '@src/config';

export interface GetPlanOrdersParams {
  applicationId: string;
  page?: number;
  size?: number;
  sort?: string[];
}

export interface GetPlanOrderParams {
  applicationId: string;
  orderId: string;
}

export interface ApiResponse<T> {
  success: boolean;
  message?: string;
  data: T;
}

export interface PaginatedResponse<T> {
  content: T[];
  pageIndex: number;
  hasNext: boolean;
  hasPrevious: boolean;
  totalPages: number;
  totalElements: number;
}

// Order 관련 타입 정의
export type OrderStatus = 'Created' | 'Paid' | 'Failed' | 'Refunded' | 'Canceled';

export type PaymentChannel = 'TossPG' | 'Redpoint' | 'Invoice';

export type PaymentMethod = 'Card' | 'Transfer' | 'EasyPay';

export interface ApplicationOrderResponseDto {
  id: string;
  status: OrderStatus;
  createdAt: string; // ISO date-time
  productName: string;
  price: number;
  payerId?: string;
  paymentChannel: PaymentChannel;
  paymentMethod: PaymentMethod;
  receiptUrl?: string;
  paymentRequestId?: string;
  payerName?: string;
  payerEmail?: string;
  payerPhone?: string;
  canceledAt?: string; // ISO date-time
  paymentHistoryId: string;
}

const api = getDefaultAxiosInstance();

const baseURL = `https://${CORE_SERVER_HOST}/manage/pay`;

export const getPlanOrders = async (params: GetPlanOrdersParams) => {
  const { applicationId, page, size, sort } = params;
  const queryParams: Record<string, unknown> = {};
  
  if (page !== undefined) queryParams.page = page;
  if (size !== undefined) queryParams.size = size;
  if (sort !== undefined) queryParams.sort = sort;

  return api.get<ApiResponse<PaginatedResponse<ApplicationOrderResponseDto>>>(
    `${baseURL}/applications/${applicationId}/orders`,
    { params: queryParams }
  );
};

export const getPlanOrder = async (params: GetPlanOrderParams) => {
  const { applicationId, orderId } = params;
  return api.get<ApiResponse<ApplicationOrderResponseDto>>(
    `${baseURL}/applications/${applicationId}/orders/${orderId}`
  );
};

